export default "__VITE_ASSET__khlRwdhF__"